// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"362":"292a40fa","639":"fc6c17d6"}[chunkId] + ".chunk.js";
};